"use client";

import { useState } from "react";
import { MapPin, Phone, Mail, Send, ChevronDown } from "lucide-react";
import "./index.css";

export const offices = [
  {
    name: "Registered Office",
    address:
      "Suite 1101, 11th Floor, Trade Center Near Jung Press, I.I Chundrigar Road, Karachi",
    phone: "(+92) 21-32622075",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14481.540450652528!2d67.0102072!3d24.8506932!3m2!1i1024!2i768!4f13.1!2m1!1sSuite%201101%2011th%20Floor%20Trade%20Center%20Near%20Jung%20Press%20.ii%20Chundrigar%20Road%20Karachi!5e0!3m2!1sen!2s!4v1741125564598!5m2!1sen!2s",
  },
  {
    name: "Branch Office",
    address:
      "Suite 92, 2nd Floor, PSX Main Building, I.I Chundrigar Road, Karachi",
    phone: "(+92) 21-32622075",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.439464337989!2d66.99372217832995!3d24.84883588885685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06f79533c3%3A0x688986c88631e98a!2sI.I%20Chundrigar%20Rd%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1741125744685!5m2!1sen!2s",
  },
];

export default function ContactUsEnhanced() {
  const [activeOffice, setActiveOffice] = useState(0);
  return (
    <div className="contact-container">
      <div className="hero-section">
        <div className="hero-content">
          <h1 style={{ lineHeight: "30px" }} className="hero-title">
            Get in Touch <br />
            <span style={{ fontSize: 16 }}>
              We're here to help and answer any question you might have
            </span>
          </h1>
        </div>
        <div className=""></div>
      </div>

      <div className="content-section">
        <div className="contact-card">
          <div className="offices-tabs">
            {offices.map((office, index) => (
              <button
                key={index}
                className={`office-tab ${
                  index === activeOffice ? "active" : ""
                }`}
                onClick={() => setActiveOffice(index)}
              >
                {office.name}
              </button>
            ))}
          </div>
          <div className="office-details">
            <h2 className="office-name">{offices[activeOffice].name}</h2>
            <p className="office-info">
              <MapPin size={18} /> {offices[activeOffice].address}
            </p>
            <p className="office-info">
              <Phone size={18} /> {offices[activeOffice].phone}
            </p>
            <p className="office-info">
              <Mail size={18} /> {offices[activeOffice].email}
            </p>
          </div>
          <div className="map-container">
            <iframe
              src={offices[activeOffice].mapSrc}
              className="map-frame"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`Google Map - ${offices[activeOffice].name}`}
            ></iframe>
          </div>
        </div>

        <div className="contact-form-container">
          <h2 className="form-title">Send us a Message</h2>
          <form className="contact-form">
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="name"
                required
                placeholder="Your Name"
              />
              <label htmlFor="name">Your Name</label>
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                required
                placeholder="Your Email"
              />
              <label htmlFor="email">Your Email</label>
            </div>
            <div className="form-group">
              <input
                type="text"
                id="subject"
                name="subject"
                required
                placeholder="Subject"
              />
              <label htmlFor="subject">Subject</label>
            </div>
            <div className="form-group">
              <textarea
                id="message"
                name="message"
                rows={5}
                required
                placeholder="Your Message"
              ></textarea>
              <label htmlFor="message">Your Message</label>
            </div>
            <button type="submit" className="submit-button">
              <Send size={18} />
              Send Message
            </button>
          </form>
        </div>
      </div>

      <div className="scroll-indicator">
        <p>Scroll for more</p>
        <ChevronDown size={24} />
      </div>
    </div>
  );
}
